<a
  data-request-view
  [routerLink]="detailsPath()"
  (click)="savePreviousParams()"
  class="flex size-8 items-center justify-center rounded-md border border-neutral-200 bg-white transition-colors hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-updated-primary-300"
  [attr.aria-label]="'requests_view_workflow_button' | transloco"
  libPermissions
  [featurePermissions]="[appPermissions.workflow.view]"
  [userPermissions]="request().permissions">
  <lib-view-icon [iconClass]="'size-4 text-neutral-700'" />
</a>

@if (request().is_triggable) {
  <button
    data-request-trigger
    type="button"
    (click)="triggerRequest()"
    class="flex size-8 items-center justify-center rounded-md bg-primary-800 transition-colors hover:bg-primary-900 focus-visible:ring-2 focus-visible:ring-updated-primary-300 cursor-pointer"
    [attr.aria-label]="'requests_start_request_button' | transloco"
    libPermissions
    [featurePermissions]="[appPermissions.workflow.trigger]"
    [userPermissions]="request().permissions">
    <lib-arrow-left-icon
      [iconClass]="'size-4 text-white rotate-180 rtl:rotate-0'" />
  </button>
}
